import { APIs, API_BASE_URL, SERVICEURL } from "../constants/Constants";
import axiosInterceptor from "../helpers/Interceptor";

export const setGatewayActive = async (firmId, gatewayId, appVersion, active) => {
  try {
    const response = await axiosInterceptor.post( `${APIs.GATEWAYHEALTH}/mapping/active`, null, { params: { firmId, gatewayId, appVersion, active, }, } );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getGatewayHealth = async (intervalHours = 24, gatewayStatus = "active") => {
  try {
    const response = await axiosInterceptor.post( `${APIs.GATEWAYHEALTH}/health?intervalHours=${intervalHours}&gatewayStatus=${gatewayStatus}`, {
      data: {},
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getGatewayHeartbeats = async (
  gatewayId,
  intervalHours = 24,
  page = 0,
  size = 10,
  appVersion
) => {
  try {
    const response = await axiosInterceptor.post(`${APIs.GATEWAYHEALTH}/${gatewayId}/heartbeats`, null, { params: { intervalHours, page, size, appVersion, }, } );

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else
      return error.response;
  }
};

export const getGatewayStrip = async (
  gatewayId,
  intervalHours = 24,
  appVersion
) => {
  try {
    const response = await axiosInterceptor.get(
      `${APIs.GATEWAYHEALTH}/${gatewayId}/heartbeats/strip`,
      {
        params: {
          intervalHours,
          appVersion,
        },
      }
    );

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else
      return error.response;
  }
};